exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".folded:not(.folded-open) :host .nav-link > .nav-link-title,\n.folded:not(.folded-open) :host .nav-link > .nav-link-badge {\n  opacity: 0;\n  transition: opacity 200ms ease; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/REPO/FacturacionWeb/src/app/core/components/navigation/vertical/nav-item/nav-vertical-item.component.scss
// module id = ../../../../../src/app/core/components/navigation/vertical/nav-item/nav-vertical-item.component.scss
// module chunks = main